<template>
   <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <ddoClientList ref="myInvoiceList" :loading="loading" :level="levels[0]" 
            :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
            :customSlotNames="levels[0].customSlotNames"
            @loading="refresh_loading"
            @row="refresh_row"
            @childKey="refresh_childKey"
            @errors="refresh_errors"
         >

            <template v-slot:header="{ errors }">
               <span></span>
            </template>

            <template slot="searchengine" slot-scope="props">
               <!--<p>
               <b-radio-group id="net_public" v-model="levels[0].searchValues.net_public" label="Public/Privé" @change="filter_rows(0)">
                  <b-radio value="">Tous</b-radio>
                  <b-radio value="true">PUBLIC</b-radio>
                  <b-radio value="false">PRIVE</b-radio>
               </b-radio-group>
               <b-radio-group id="net_ipnature" v-model="levels[0].searchValues.net_ipnature" label="Nature :" @change="filter_rows(0)">
                  <b-radio value="">Tous</b-radio>
                  <b-radio value="4">IPv4</b-radio>
                  <b-radio value="6">IPv6</b-radio>
               </b-radio-group>
               </p>-->
            </template>

            <template slot="refresh" slot-scope="props">
               <v-icon @click="refresh_row(props.row.inv_pk)" x-large color="orange darken-2">mdi-sync</v-icon>
               <span>{{ props.row.inv_bm_refresh_count }}</span>
            </template>

            <template slot="inv_total_price" slot-scope="props">
               <span class="headline">{{ $n(props.row.inv_total_price,'currency') }}</span>
            </template>

            <template slot="inv_exported_to_accounting" slot-scope="props">
               <b-checkbox disabled v-model="props.row.inv_exported_to_accounting"></b-checkbox>
            </template>

            <template slot="inv_bm_last_synchro" slot-scope="props">
               <slot name="inv_bm_last_synchro" v-scope="props">
                  <p>{{ $api._d(props.row.inv_bm_last_synchro,'timestamp1') }}</p>
               </slot>
            </template>

            <template slot="inv_pdf_link" slot-scope="props">
               <span v-if="props.row.inv_pdf_link!=null"><a :href="$api.get_pdf_link(props.row.inv_pdf_link,$config)" target="_blank"><v-icon x-large color="red darken-2">mdi-file-pdf</v-icon></a></span>
            </template>

            <template v-slot:dialogform="{ row, level }">
               <CardUpdatableInvoice ref="myCardInvoice" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
               @errors="refresh_errors"
               />
            </template>

            <template v-slot:child_row="{ props }">
            </template>

            <template v-slot:superheader="{ errors }">
               <h2>{{ $t('titles.inv') }}</h2>
            </template>

         </ddoClientList>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import BasicList from '@/views/BasicList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableInvoice from '@/components/partials/CardUpdatableInvoice.vue';

let initial_row = {}

export default {
   name: 'invoice',
   mixins: [BasicList],
   components: {
      CardUpdatableInvoice,
   },
   data: () => {
      return {
         _this: null,
         loading: false,

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [
            {
               api_code: 'invoice',
               api_prefix: 'inv',
               row: {},
               level: 0,
               errors: [],
               columns: [ 'refresh', 'inv_date', 'cus_name', 'inv_code', 'ins_name', 'inv_total_price', 'inv_exported_to_accounting', 'inv_pdf_link', 'inv_bm_last_synchro'],
               customSlotNames: ['refresh','inv_total_price','inv_pdf_link','inv_bm_last_synchro','inv_exported_to_accounting'],
               searchValues: {
                  net_public: null,
                  net_ipnature: '4',
               },
               options: {
                  showChildRowToggler: false,
                  withChild: false,
                  hiddenColumns: [],
                  headings: {
                     _pk: i18n.t('headers.actions'),
                     refresh: i18n.t('headers.action_refresh'),
                     inv_name: i18n.t('headers.name'),
                     inv_date: i18n.t('headers.inv_date'),
                     inv_code: i18n.t('headers.inv_code'),
                     cus_name: i18n.t('headers.cus_name'),
                     ins_name: i18n.t('headers.ins_name'),
                     inv_total_price: i18n.t('headers.inv_signed_total_price'),
                     inv_pdf_link: i18n.t('headers._pdf_link'),
                     inv_bm_refresh_count: i18n.t('texts.refresh_count'),
                     inv_bm_last_synchro: i18n.t('headers._refreshed_on'),
                     inv_exported_to_accounting:  i18n.t('headers._exported'),
                     _update: i18n.t('headers.updated_on')
                  },
                  rowClassCallback: function(row) {
                     if ( row.ins_is_payable==true ) {
                        return "row-not-paid";
                     } else {
                        return "row-paid";
                     }
                  },
                  perPage: 100,
                  perPageValues: [100,200,400],
                  texts: {
                  },
                  uniqueKey: 'inv_pk',
                  sortable: ['inv_code','_update'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
                  columnsClasses: {
                     refresh: 'column_refresh_1_btn',
                     inv_total_price: 'text-right',
                  },
                  columnsDisplay: {
                     _update: 'desktop',
                     inv_desc: 'desktop',
                     inv_pk: 'desktop',
                  },
                  customFilters: [],
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ]
               },
               dialogValues: {
                  headers: {
                     create: i18n.t('texts.inv_create_title'),
                     update: i18n.t('texts.inv_update_title'),
                     delete: i18n.t('texts.inv_delete_title'),
                  },
                  macros: [],
                  samePLF: true,
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  disable_create: false,
                  disable_update: false,
                  disable_delete: false,
                  header_value_function: function(row) { return row['inv_code']; }
               },
            },
         ],

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.show_dialog    = this.show_dialog;
      this.levels[0].callbacks.prepare_update = this.prepare_update;    
      this.levels[0].callbacks.refresh_errors = this.refresh_errors;
   },

   async mounted() {
   },

   methods: {

      async refresh_row(_pk) {
         var { errorinfos, api_response } = await this.$api.updateRow(this.$router,this.levels[0].api_code,_pk,{},'refresh');
         if ( api_response.error==0 ) {
            this.$refs.myInvoiceList.refresh_rows();
         }
      },

   }
}
</script>

<style>
.column_action_2_btn {
   width: 100px;
}
.column_refresh_1_btn {
   width: 100px;
}
.row-paid {
   background-color: rgb(204, 247, 204) !important;
}
.row-not-paid {
   background-color: rgb(245, 208, 208) !important;
}
</style>